import userInfo from "../../function/userInfo";
import i18n from "../../locales/i18n";
import * as API from "../ApiConfig";

export default {
  DoGetSuggestionAllocationNumber() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI
      .post("/api/Allocation/GetSuggestionAllocationNumber", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSuggestionAllocationItemNumber(allocationId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      allocationId: allocationId,
    };
    return API.peakRealTimeAPI
      .post("/api/Allocation/GetSuggestionAllocationItemNumber", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertAllocation(allocationList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      allocationList: allocationList,
    };
    return API.peakRealTimeAPI
      .post("/api/Allocation/InsertAllocation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertAllocationItem(allocationItemList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      allocationItemList: allocationItemList,
    };
    return API.peakRealTimeAPI
      .post("/api/Allocation/InsertAllocationItem", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateAllocation(allocation) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      allocation: allocation,
    };
    return API.peakRealTimeAPI
      .post("/api/Allocation/UpdateAllocation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateAllocationItem(allocationItem) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      allocationItem: allocationItem,
    };
    return API.peakRealTimeAPI
      .post("/api/Allocation/UpdateAllocationItem", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateAllocationIsDeleted(allocationId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      allocationId: allocationId,
    };
    return API.peakRealTimeAPI
      .post("/api/Allocation/UpdateAllocationIsDeleted", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateAllocationItemIsDeleted(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      allocationItemId: input.allocationItemId,
      allocationId: input.allocationId,
    };
    return API.peakRealTimeAPI
      .post("/api/Allocation/UpdateAllocationItemIsDeleted", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateAllocationIsArchived(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      allocationId: input.allocationId,
      isArchived: input.isArchived,
    };
    return API.peakRealTimeAPI
      .post("/api/Allocation/UpdateAllocationIsArchived", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateAllocationItemIsArchived(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      allocationItemId: input.allocationItemId,
      isArchived: input.isArchived,
    };
    return API.peakRealTimeAPI
      .post("/api/Allocation/UpdateAllocationItemIsArchived", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetAllocationList() {
    let _input = {
      merchantId: userInfo.MerchantId(),
      isUseMainDatabase: true,
    };
    return API.peakAPI.post("/api/Allocation/GetAllocationList", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetAllocationItemList(allocationId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      allocationId: allocationId,
      isUseMainDatabase: true,
    };
    return API.peakAPI
      .post("/api/Allocation/GetAllocationItemList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateAllocationDefault() {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/Allocation/CreateAllocationDefault", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
};
